export default (params) => ({
  trigger: {
    name: 'filter_and_sort.select_more_less_filters',
    params: params,
  },
  config: {
    schema: {
      property_name: {
        type: 'string',
      },
      method: {
        enum: [
          'select_more',
          'select_less',
          'expand',
          'collapse',
        ],
      },
      sub_feature: {
        enum: [
          'filter_and_sort_overlay',
          'filter_list',
        ],
      },
    },
    event: {
      name: 'interact_with_property',
      params: {
        property_value: null,
      },
    },
  },
});
